// src/components/SocialShareButtons.tsx

import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import GoogleIcon from '@mui/icons-material/Google';
import PrintIcon from '@mui/icons-material/Print';
import { useLocation } from 'react-router-dom';

interface SocialShareButtonsProps {
  title?: string;
}

const SocialShareButtons: React.FC<SocialShareButtonsProps> = ({ title = 'Confira esta notícia' }) => {
  const encodedTitle = encodeURIComponent(title);
  const fullURL = window.location.href;
  const encodedURL = encodeURIComponent(fullURL);

  const shareLinks = {
    whatsapp: `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedURL}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`,
    twitter: `https://twitter.com/intent/tweet?url=${encodedURL}&text=${encodedTitle}`,
    google: `https://www.google.com/bookmarks/mark?op=edit&bkmk=${encodedURL}&title=${encodedTitle}`
  };

  const openInNewTab = (shareUrl: string) => {
    window.open(shareUrl, '_blank', 'noopener,noreferrer');
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <Box display="flex" justifyContent="center" gap={2} flexWrap="wrap">
      <Tooltip title="Compartilhar no WhatsApp">
        <IconButton color="success" onClick={() => openInNewTab(shareLinks.whatsapp)}>
          <WhatsAppIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Compartilhar no Facebook">
        <IconButton color="primary" onClick={() => openInNewTab(shareLinks.facebook)}>
          <FacebookIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Compartilhar no Twitter">
        <IconButton color="primary" onClick={() => openInNewTab(shareLinks.twitter)}>
          <TwitterIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Salvar no Google Bookmarks">
        <IconButton color="error" onClick={() => openInNewTab(shareLinks.google)}>
          <GoogleIcon />
        </IconButton>
      </Tooltip>

      <Tooltip title="Imprimir notícia">
        <IconButton color="default" onClick={handlePrint}>
          <PrintIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default SocialShareButtons;
